import React from "react";
import CompanyBranchesTable from "./CompanyBranchesTable";

const CompanyBranches = () => {
  return (
    <div>
      <CompanyBranchesTable />
    </div>
  );
};

export default CompanyBranches;
